import React, { SetStateAction, useState } from "react";
import SelectComponent from "./select";
import { useCampaigns } from "../../hooks/useCampaign";

export default function SortByProject({
  handleChange,
}: {
  handleChange?: React.Dispatch<React.SetStateAction<{}>>;
}) {
  const { data, isLoading } = useCampaigns();
  const option =
    data?.map((campaign) => ({
      value: campaign._id,
      label: campaign.campaign_name,
    })) ?? [];

  const options = [{ value: "", label: "All campaigns" }, ...option];
  return (
    <SelectComponent
      selectoptions={options}
      selected={options[0]}
      handleChange={handleChange}
    />
  );
}
